module.exports = __webpack_public_path__ + "img/tooth-restored.644d2146.svg";